<style lang="scss" scoped>
.left-content {
  position: absolute;
  width: 415px;
  top: 135px;
  left: 107px;
  .water-con {
    height: 168px;
    margin-bottom: 20px;
  }
  .water-percent {
    height: 258px;
  }
}
.right-content {
  position: absolute;
  width: 415px;
  top: 135px;
  right: 43px;
  .water-con {
    height: 168px;
    margin-bottom: 20px;
  }
}
</style>

<template>
  <div>
    <div class="left-content">
      <div class="water-con">
        <water-cons :waterData="waterData"></water-cons>
      </div>
      <div class="water-con">
        <ele-cons :eleData="eleData"></ele-cons>
      </div>
      <div class="water-percent">
        <ele-percent :perData="eleData" :percent="percent"></ele-percent>
      </div>
    </div>
    <div class="right-content">
      <div class="water-con">
        <illumina-ele :lighting="lighting"></illumina-ele>
      </div>
      <div class="water-con">
        <power-ele :power="power"></power-ele>
      </div>
      <div class="water-con">
        <air-ele :air="air"></air-ele>
      </div>
      <div class="water-con">
        <other-ele :air="other"></other-ele>
      </div>
    </div>
  </div>
</template>
<script>
import EleCons from "../../components/ele-cons.vue";
import WaterCons from "../../components/water-cons.vue";
import IlluminaEle from "../../components/illumina-ele.vue";
import PowerEle from "../../components/power-ele.vue";
import AirEle from "../../components/air-ele.vue";
import OtherEle from "../../components/other-ele.vue";
import { getEnergyData } from "@/api/index.js";
import ElePercent from "../../components/ele-percent.vue";
export default {
  components: {
    EleCons,
    WaterCons,
    IlluminaEle,
    PowerEle,
    AirEle,
    OtherEle,
    ElePercent,
  },
  data() {
    return {
      eleData: {},
      waterData: {},
      lighting: {},
      power: {},
      air: {},
      other: {},
      percent: {},
      timer:null,
    };
  },
  created() {
    this.getEnergy();
    this.timer = setInterval(() => {
      this.getEnergy();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    async getEnergy() {
      let { data: res } = await getEnergyData();
      this.percent = res.proportion;
      this.eleData = res.electricity;
      this.waterData = res.water;
      this.lighting = res.lighting;
      this.power = res.power;
      this.air = res.air;
      this.other = res.other;
    },
  },
};
</script>
